<template>
  <div>

    <a-button type="primary" class="float-right" @click="showDrawer({})">Crear Perfil +</a-button> <br> <br>

    <a-table :columns="columns" :dataSource="rows" :rowSelection="{onChange:onSelect, type:'radio' }">
      <span slot="key" slot-scope="index, profile" >
        <h5 style="margin-top:8px">{{profile.namePerfil}}</h5>
        <!-- <a-button type="primary" size="small" icon="edit" @click="showDrawer(profile)"> </a-button> -->

        <!-- <a-switch :checked="record.status" disabled @change='onChange'/> -->
      </span>
      <!-- <span slot="banners" slot-scope="index, banners" >
        <div class="row" style="overflow-x:auto; overflow-y:none;">
          <span v-for="banner in banners" :key="banner.id" style="padding: 0px 5px"><img    :src="banner.urlBanner" class="rounded-pill float-left" style="height: 40px;" alt=""></span>
        </div>
      </span> -->

      <span slot="banners" slot-scope="index, profile" >
        <p>{{profile.namePerfil}}</p>
      </span>

      <!-- <span slot="action" slot-scope="slider">
        <a-button type="primary" size="small" icon="form" @click="showDrawer(profile)"> </a-button>
      </span> -->

    </a-table>
    <a-drawer
      :title="titleDetail"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="itemDetailShow"
      width=740>

      <ItemDetails :profile.sync="profile" :clusters.sync="clusters" :isUpdated="isUpdated" closable="true" v-on:closeDetail="onClose($event)" v-on:updateProfiles="update()"/>

    </a-drawer>

  </div>
</template>
<script>

import ItemDetails from './itemDetails'

import { RepositoryFactory } from '@/repository/RepositoryFactory'

const BannersRepository = RepositoryFactory.get('banners')

const columns = [
  {
    title: 'Perfiles',
    dataIndex: 'key',
    key: 'key',
    slots: { title: 'key' },
    scopedSlots: { customRender: 'key' },
  },

  {
    title: 'Nombre de Cluster',
    dataIndex: 'banners',
    key: 'banners',
    scopedSlots: { customRender: 'banners' },
  },

]

export default {
  name: 'TableProfiles',
  components: {
    ItemDetails,
  },
  data() {
    return {
      columns,
      itemDetailShow: false,
      profile: {},
    }
  },
  props: ['data', 'clusters'], 
  created(){
    console.log('inicio');
  },
  computed: {
    titleDetail: function() {
      return this.isUpdated ? ('Configuración de Perfil: ' + this.profile.namePerfil) : 'Nuevo Perfil'
    },
    isUpdated: function () {
      return this.profile.hasOwnProperty('namePerfil')
    },
    rows: function() {
      return this.data.map((item, index) => {
        console.log(item)

        var object = {
          key: index + 1,
          namePerfil: item.namePerfil,
          nameCluster: item.clusterName,
          idCluster: item.idCluster,
          banners: [],
        }

        try {
          console.log(item.idCluster)
          const data = BannersRepository.getBannersByCluster(item.idCluster).then(({ data }) => {
            console.log(this.rows, 'row')
            this.rows.banners = data.data
          })
        } catch (error) {
          this.$notification['warning']({
            message: error.code,
            description: error.message,
          })
        }

        return object
      })
    }
  
  },
  methods:{

    nameCluster(id) {
      // this.clusters.find((x){
      //     console.log(x);
      //  });

      return ''
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`)
    },
    showDrawer(profile) {
      this.profile = profile
      this.itemDetailShow = true
    },
    onClose($event) {
      this.itemDetailShow = false;
    },
    onSelect(record, selected, selectedRows, nativeEvent) {
      console.log(selected[0])
      this.showDrawer(selected[0])
    },
    update(){
      console.log("UPDATE");
      this.$emit('update', true)
    }

  },
}
</script>
